import { useLines } from "@/features/lines/hooks";
import { useLineChains } from "@/features/lines/chain/hooks";
import type { ReportScopeKind } from "@/types/production-report.types";

// Spec 083 (T077) — o RECORTE: uma linha, ou a cadeia que a contém.
//
// Um seletor só, com as cadeias agrupadas à parte. Dois seletores ("tipo" e depois "qual") fariam o
// gestor escolher um conceito antes de escolher a coisa — e "cadeia" é vocabulário novo para ele.
//
// A cadeia é endereçada pela linha de menor nível, não por um identificador próprio: ela não tem
// tabela, e inventar um id exigiria a entidade que a decisão de produto recusou.

interface Props {
  scope: ReportScopeKind;
  lineId: string;
  onChange: (next: { scope: ReportScopeKind; lineId: string }) => void;
}

export function ScopePicker({ scope, lineId, onChange }: Props) {
  const { data: lines = [] } = useLines();
  const { data: chains } = useLineChains();
  const cadeias = chains?.items ?? [];
  const valor = `${scope}:${lineId}`;

  return (
    <label className="flex flex-col gap-1 text-[11px] text-text-secondary">
      Recorte
      <select
        className="rounded-md border border-border-default bg-bg-surface px-2 py-1.5 text-[13px]"
        value={valor}
        aria-label="Recorte do relatório"
        onChange={(e) => {
          const [kind, id] = e.target.value.split(":");
          onChange({ scope: kind === "chain" ? "chain" : "line", lineId: id ?? "" });
        }}
      >
        <optgroup label="Linha">
          {lines.map((l) => (
            <option key={l.id} value={`line:${l.id}`}>
              {l.name}
            </option>
          ))}
        </optgroup>
        {cadeias.length > 0 ? (
          <optgroup label="Cadeia">
            {cadeias.map((c) => (
              <option key={c.id} value={`chain:${c.id}`}>
                {c.label}
              </option>
            ))}
          </optgroup>
        ) : null}
      </select>
    </label>
  );
}
